import { http } from "./http";

export const tasksApi = {
  list: () => http.get("/tasks").then((r) => r.data),

  create: (payload) => http.post("/tasks/create", payload).then((r) => r.data),

  get: (uid) => http.get(`/tasks/${uid}`).then((r) => r.data),

  updateSettings: (uid, payload) =>
    http.put(`/tasks/${uid}/settings`, payload).then((r) => r.data),

  updatePool: (uid, payload) =>
    http.put(`/tasks/${uid}/pool`, payload).then((r) => r.data),

  start: (uid) => http.post(`/tasks/${uid}/start`).then((r) => r.data),
  pause: (uid) => http.post(`/tasks/${uid}/pause`).then((r) => r.data),
  stop: (uid) => http.post(`/tasks/${uid}/stop`).then((r) => r.data),
  resume: (uid) => http.post(`/tasks/${uid}/resume`).then((r) => r.data),

  releaseAccounts: (uid) => http.post(`/tasks/${uid}/release-accounts`).then((r) => r.data),

  dailyStats: (uid) => http.get(`/tasks/${uid}/daily-stats`).then((r) => r.data),

  history: (uid) => http.get(`/tasks/${uid}/history`).then((r) => r.data),

  remove: (uid) => http.delete(`/tasks/${uid}`).then((r) => r.data),

  logs: (uid, limit = 200) =>
    http.get(`/tasks/${uid}/logs`, { params: { limit } }).then((r) => r.data),
};
